import querystring from 'querystring';
import { type Endpoints } from '../constants/endpoints';
import { type Requester } from './index';
import { type ResponseTimeHistoryParams, type ResponseTimeHistoryResponse } from '../types/responseTimeStatistics';

const buildQueryParams = (params: ResponseTimeHistoryParams): Record<string, string | number> => {
  const queryParams: Record<string, string | number> = {
    event: params.event,
    from: params.from,
    to: params.to,
  };

  if (params.partnerId?.length) queryParams.partnerId = params.partnerId.join(',');
  if (typeof params.bucket === 'number') queryParams.bucket = params.bucket;

  return queryParams;
};

export function createResponseTimeStatistics({ authorizedGET }: Requester, endpoints: Endpoints) {
  const getHistory = async (params: ResponseTimeHistoryParams): Promise<ResponseTimeHistoryResponse> => {
    const url = `${endpoints.responseTimeStatistics.root}?${querystring.stringify(buildQueryParams(params))}`;
    return authorizedGET<ResponseTimeHistoryResponse>(url);
  };

  return { getHistory };
}
